module.exports = __webpack_public_path__ + "static/lohnbuchhaltung-f7b639520c8ea5221ee2f20793e19190.png";